<template>
  <footer class="page-footer">
    <div class="container my-auto">
      <div class="copyright text-center my-auto">
        <span>Copyright © SensorUp {{currentYear}}</span>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },
}
</script>
